import { render, staticRenderFns } from "./FeeConfigDetailDiscount.vue?vue&type=template&id=32798aed&scoped=true"
import script from "./FeeConfigDetailDiscount.vue?vue&type=script&lang=js"
export * from "./FeeConfigDetailDiscount.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigDetailDiscount.vue?vue&type=style&index=0&id=32798aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32798aed",
  null
  
)

export default component.exports